import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { renderIconByLabel } from '../../content/icons';
import {
  setCurrentMobileTab,
  setCurrentTab,
  setOpenModales,
} from '../../store/global';
import { TiSortAlphabetically, TiSortNumerically } from 'react-icons/ti';
import { FaImages, FaLink } from 'react-icons/fa';
import { MdSmartButton } from 'react-icons/md';
import {
  isBuiltinTabId,
  isTabCampaignAccessible,
  canEditItemForItem,
} from '../../utils/item';
import { canUseMjForItem, isMjForItem } from '../../utils/auth';

export const TabInList = props => {
  const { tabId, itemId, useMobileTabState, mobileCurrentTab } = props;

  const tab = useSelector(state => state.items[tabId]);
  const currentTab = useSelector(state => state.global.currentTab);
  const items = useSelector(state => state.items);
  const listCampaignsId = useSelector(state => state.global.listCampaignsId);
  const canEdit = canEditItemForItem(tab, items);
  const isHardReadOnly = tab?.readOnlyMode === 'hard';
  const canBypassHardReadOnly =
    isMjForItem(tab, items) || canUseMjForItem(tab, items);
  const dispatch = useDispatch();
  const activeTabId = useMobileTabState ? mobileCurrentTab : currentTab;

  const setDefaultTabs = () => {
    switch (tabId) {
      case 'text':
        return (
          <div className='flex items-center gap-05'>
            <TiSortAlphabetically /> Textes
          </div>
        );

      case 'img':
        return (
          <div className='flex items-center gap-05'>
            <FaImages /> Images
          </div>
        );

      case 'link':
        return (
          <div className='flex items-center gap-05'>
            <FaLink /> Liens
          </div>
        );

      case 'num':
        return (
          <div className='flex items-center gap-05'>
            <TiSortNumerically /> Nombres
          </div>
        );

      case 'conditions':
        return (
          <div className='flex items-center gap-05'>
            <MdSmartButton /> Boutons
          </div>
        );

      default:
        break;
    }
  };

  const isAccessible =
    (!tab && isBuiltinTabId(tabId)) ||
    isTabCampaignAccessible(tab, items, listCampaignsId);

  return (
    isAccessible && (
    <div
      onClick={() =>
        useMobileTabState
          ? dispatch(setCurrentMobileTab({ itemId, tabId }))
          : dispatch(setCurrentTab(tabId))
      }
      onDoubleClick={e => {
        e.stopPropagation();
        if (!canEdit) return;
        if (isHardReadOnly && !canBypassHardReadOnly) return;
        tabId !== 'link' &&
          tabId !== 'img' &&
          tabId !== 'text' &&
        tabId !== 'num' &&
        tabId !== 'conditions' &&
        dispatch(setOpenModales({ id: tabId, open: true }));
      }}
      className={`px-1 py-03 transition hover:opacity-50 cursor-pointer flex items-center gap-05 ${
        activeTabId === tabId ? 'bg-primary-d' : ''
      }`}
    >
      {!tab?.label ? (
        setDefaultTabs()
      ) : (
        <>
          <div>{renderIconByLabel(tab?.icon)}</div>
          {tab?.label}
        </>
      )}
    </div>
    )
  );
};
